
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/typing-indicator",
      function () {
        return require("private-next-pages/x/api/chat/typing-indicator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/typing-indicator"])
      });
    }
  